import React from 'react';

//import './css/loading.css';

const Loading = () => {



	return (
		<>
			{/*<div className="loading-area">
				<span className="loader">Loading...</span>
				<span className="load_anim1"></span>
				<span className="load_anim2"></span>
			</div>*/}
		</>
	)
}

export default Loading;